import { render, staticRenderFns } from "./TeacherView.vue?vue&type=template&id=9fedce02&scoped=true&"
import script from "./TeacherView.vue?vue&type=script&lang=js&"
export * from "./TeacherView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fedce02",
  null
  
)

export default component.exports